import makeStyles from "@mui/styles/makeStyles";

const menuListItem = {
  fontWeight: 400,
  fontSize: "12px",
  lineHeight: "24px",
  color: "#1E49E2",
  padding: "0px",
  overflow: "visible",
  marginBottom: "4px",
  "&:hover": {
    outline: "2px solid #1E49E2",
    outlineOffset: "2px",
  },
  "&:focus-within": {
    outline: "2px solid #1E49E2",
    outlineOffset: "2px",
  },
  "& a:focus, & a:focus-visible": {
    outline: "none",
  },
};

export const useStyles = makeStyles((theme) => ({
  popper: {
    zIndex: 1300,
    top: "70px !important",
  },
  popover: {
    "& .MuiPopover-paper": {
      borderRadius: "12px",
    },
  },
  containerDiv: {
    display: "flex",
  },
  menulistContainer: {
    padding: "30px 30px 45px 30px",
    maxWidth: "50vw",
  },
  popoverContent: {
    padding: theme.spacing(2),
  },
  titleContainer: {
    display: "flex",
    height: "52px",
    gap: "10px",
  },
  iconContainer: {
    padding: "5px",
    backgroundColor: "#FFFFFF",
  },
  dividerContainer: {
    padding: "8px 0px 15px 0px",
  },
  typography: {
    padding: theme.spacing(2),
  },
  menuHeader: {
    fontWeight: 700,
    height: "24px",
    fontSize: "12px",
    padding: "15px 0px",
  },
  heading: {
    minHeight: "24px",
    fontWeight: 700,
    lineHeight: "24px",
    fontSize: "14px",
    color: "#0C233C",
    padding: "8px 0px 1.5rem 0px",
    [theme.breakpoints.down("md")]: {
      padding: "0px 0px 8px 0px",
      whiteSpace: "normal",
      overflowWrap: "anywhere",
    },
  },
  LeapHeading: {
    height: "24px",
    fontWeight: 700,
    lineHeight: "24px",
    fontSize: "14px",
    color: "#0C233C",
  },
  content: {
    fontWeight: 600,
    fontSize: "12px",
    lineHeight: "24px",
    color: "#595959",
    width: "216px",
  },
  menuListItem,
  menuIconStyle: {
    height: "15px !important",
    width: "15px !important",
    padding: "15px 0px",
  },
  svgIconStyle: {
    height: "20px",
    width: "20px",
  },
  descriptionContainer: {
    maxWidth: "400px",
    backgroundColor: "#F4F6F8",
    padding: "30px 34px",
    borderRadius: "12px",
  },
  descriptionTitleContainer: {
    display: "flex",
    alignItems: "center",
    height: "47px",
    gap: "10px",
  },
  paper: {
    borderRadius: "12px",
    left: "145px",
    position: "relative",
    maxHeight: "80vh",
    overflowY: "scroll",
    [theme.breakpoints.down("lg")]: {
      marginRight: "20px",
      marginLeft: "20px",
      left: 20,
    },
    [theme.breakpoints.down("md")]: {
      marginRight: "40px",
      marginLeft: "10px",
      left: 20,
    },
    [theme.breakpoints.down("sm")]: {
      marginRight: "50px",
      marginLeft: "-20px",
      left: 0,
    },
  },
  btnCourseFinder: {
    color: "#FFFFFF",
    textTransform: "none",
    [theme.breakpoints.down("md")]: {
      "& .MuiButton-endIcon": {
        marginLeft: 0,
      },
    },
    "&:hover": {
      outline: "2px solid white",
    },
    "&.Mui-focusVisible": {
      outline: "2px solid white",
    },
  },
  divider: {
    width: "90%",
  },
  nonGroupedList: {
    display: "flex",
    flexDirection: "column",
    flexWrap: "wrap",
    columnGap: "12px",
    height: "14rem",
    // Safari does not expand parent width for column-wrapped flex — use grid for WebKit
    "@supports (-webkit-hyphens: none)": {
      display: "grid",
      gridAutoFlow: "column",
      gridAutoColumns: "11.8rem",
      gridTemplateRows: "repeat(7, min-content)",
    },
    [theme.breakpoints.down("md")]: {
      height: "18rem",
      "@supports (-webkit-hyphens: none)": {
        gridTemplateRows: "repeat(10, min-content)",
      },
    },
  },
  nonGroupedMenuItem: {
    ...menuListItem,
    lineHeight: "28px",
    width: "11.8rem",
    textWrap: "auto",
    marginBottom: "4px",
  },
  hyperLink: {
    outline: "0px",
  },
  focus: {
    outline: "2px solid #1E49E2",
    outlineOffset: "2px",
  },
}));
